// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WDFp6","fullView":"styles_fullView__V8taA"};